import { Theme, Typography, withStyles } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React from 'react'

import { getTranslate } from '../../../localization'
import { UserForLog } from '../../../types/auditLogs'
import useStyles from '../UserInfoTooltip/styles'

interface UserInfoTooltipProps {
  user: UserForLog
}

export const getConnectionMethodLabel = (connectionMethod?: string) => {
  if (connectionMethod === 'password') return 'Password'
  if (connectionMethod === '2fa') return 'Two-factor'
  return 'Unknown'
}

const UserInfoTooltip: React.FC<UserInfoTooltipProps> = ({ user }) => {
  const classes = useStyles()

  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main
    }
  }))(Tooltip)

  return (
    <HtmlTooltip
      arrow
      interactive
      title={
        <React.Fragment>
          <div className={classes.userInfoTooltipContariner}>
            <div className={classes.userInfoTooltipHeaderContainer}>
              <Typography
                color="textSecondary"
                variant="h4"
                className={classes.userInfoHeader}>
                {getTranslate('User Info')}
              </Typography>
            </div>
            <div>
              <div className={classes.userInfoEachRow}>
                {/* <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('User ID')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.id}
                </Typography> */}
              </div>
              {user.name && (
                <div className={classes.userInfoEachRow}>
                  <Typography
                    color="textSecondary"
                    className={classes.userInfoCell}>
                    {getTranslate('Name')}
                  </Typography>
                  <Typography className={classes.userInfoColon}>:</Typography>
                  <Typography
                    color="textSecondary"
                    className={classes.userInfoCell}>
                    {user.name}
                  </Typography>
                </div>
              )}
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('Role')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate(user.role)}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('Email')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.email}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('User IP')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.ip}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('Entity ID')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.entityID}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('Entity Code')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.entityCode}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('User Agent')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {user.userAgent}
                </Typography>
              </div>
              <div className={classes.userInfoEachRow}>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate('Connection Method')}
                </Typography>
                <Typography className={classes.userInfoColon}>:</Typography>
                <Typography
                  color="textSecondary"
                  className={classes.userInfoCell}>
                  {getTranslate(
                    getConnectionMethodLabel(user.connectionMethod)
                  )}
                </Typography>
              </div>
            </div>
          </div>
        </React.Fragment>
      }>
      <div className={classes.userInformation}>
        <Typography className={classes.userInfoEmail} variant="body1">
          {(user.name || user.email).substring(0, 20)}
          {(user.name || user.email).length > 20 && '...'}
        </Typography>
        <InfoOutlinedIcon className={classes.infoIcon} />
      </div>
    </HtmlTooltip>
  )
}
export default UserInfoTooltip
